
const normalizeTemplateBlogPost = (data) => {
  const tags = data?.categories?.map((tag) => ({
    label: tag.title,
    colorScheme: tag.colorCategory
  }))

  const normalizedData = {
    sectionsHead: [
      {
        type: 'HeroNews',
        imageShape: data?.imageShape,
        blogPost: data,
        date: data?.date,
        tags,
        title: data?.title,
        description: data?.description,
        image: {
          src: data?.featuredImage?.url,
          alt: data?.featuredImage?.alternativeText
        }
      }
    ],
    sectionsBody: data?.content,
    seo: data?.seo
  }

  return normalizedData
}

export default normalizeTemplateBlogPost
